/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MatchParticipantInfoResponse
 */
export interface MatchParticipantInfoResponse {
    /**
     * 
     * @type {string}
     * @memberof MatchParticipantInfoResponse
     */
    participantId: string;
    /**
     * 
     * @type {string}
     * @memberof MatchParticipantInfoResponse
     */
    participantType: MatchParticipantInfoResponseParticipantTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof MatchParticipantInfoResponse
     */
    displayName: string;
    /**
     * 
     * @type {number}
     * @memberof MatchParticipantInfoResponse
     */
    score?: number;
    /**
     * 
     * @type {boolean}
     * @memberof MatchParticipantInfoResponse
     */
    confirmedResult?: boolean;
    /**
     * 
     * @type {number}
     * @memberof MatchParticipantInfoResponse
     */
    confirmedAt?: number;
}


/**
 * @export
 */
export const MatchParticipantInfoResponseParticipantTypeEnum = {
    USER: 'USER',
    TEAM: 'TEAM'
} as const;
export type MatchParticipantInfoResponseParticipantTypeEnum = typeof MatchParticipantInfoResponseParticipantTypeEnum[keyof typeof MatchParticipantInfoResponseParticipantTypeEnum];


/**
 * Check if a given object implements the MatchParticipantInfoResponse interface.
 */
export function instanceOfMatchParticipantInfoResponse(value: object): value is MatchParticipantInfoResponse {
    if (!('participantId' in value) || value['participantId'] === undefined) return false;
    if (!('participantType' in value) || value['participantType'] === undefined) return false;
    if (!('displayName' in value) || value['displayName'] === undefined) return false;
    return true;
}

export function MatchParticipantInfoResponseFromJSON(json: any): MatchParticipantInfoResponse {
    return MatchParticipantInfoResponseFromJSONTyped(json, false);
}

export function MatchParticipantInfoResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MatchParticipantInfoResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'participantId': json['participantId'],
        'participantType': json['participantType'],
        'displayName': json['displayName'],
        'score': json['score'] == null ? undefined : json['score'],
        'confirmedResult': json['confirmedResult'] == null ? undefined : json['confirmedResult'],
        'confirmedAt': json['confirmedAt'] == null ? undefined : json['confirmedAt'],
    };
}

export function MatchParticipantInfoResponseToJSON(json: any): MatchParticipantInfoResponse {
    return MatchParticipantInfoResponseToJSONTyped(json, false);
}

export function MatchParticipantInfoResponseToJSONTyped(value?: MatchParticipantInfoResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'participantId': value['participantId'],
        'participantType': value['participantType'],
        'displayName': value['displayName'],
        'score': value['score'],
        'confirmedResult': value['confirmedResult'],
        'confirmedAt': value['confirmedAt'],
    };
}

